export const MESSAGES_CONSTS = {
  moduleName: 'epb-messages',

  getters: {
    locale: 'locale',
    messages: 'messages'
  },
  actions: {
    setLocale: 'setLocale'
  },
  mutations: {
    setLocale: 'setLocale'
  }

};
